module.exports = __webpack_public_path__ + "img/fees.weekly.2a1d38e3.png";